import React, { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
import axios from 'axios';
import { newUTM } from './helpers';

export default function DetailActions({ addUTM, utmBatch }) {
  const [label, setLabel] = useState('Save All');

  const writeToDB = async () => {
    const payload = utmBatch;
    const url = `/wp-admin/admin-ajax.php?action=post_save_utm_codes`;

    setLabel('Saving...');

    await axios
      .post(url, payload)
      .then(() => setLabel('Save All'))
      .catch((err) => console.log(err));
  };

  // only display if group_name is set
  return (
    <div className="grid">
      <div className="detail-actions__button-group grid__col-lg-4 grid__col-lg-offset-8">
        <p className="u--margin-right-10">
          <button
            className="btn btn--blue btn--outline"
            onClick={() => addUTM((curList) => [...curList, newUTM()])}
          >
            <span className="btn__content">
              <span className="btn__text">Create New</span>
            </span>
          </button>
        </p>
        <p>
          <button className="btn btn--blue" onClick={() => writeToDB()}>
            <span className="btn__content">
              <span className="utm__save-btn btn__text">{label}</span>
            </span>
          </button>
        </p>
        <Autosave utmBatch={utmBatch} />
      </div>
    </div>
  );
}

function Autosave({ utmBatch }) {
  if (utmBatch.groupName === '') return null;

  const autoSaveToDB = async (utmBatch) => {
    const payload = utmBatch;
    const url = `/wp-admin/admin-ajax.php?action=post_save_utm_codes`;
    await axios.post(url, payload).catch((err) => console.log(err));
  };

  const debouncedSave = useCallback(
    debounce(async (utmBatch) => await autoSaveToDB(utmBatch), 500),
    []
  );

  useEffect(() => {
    if (utmBatch) debouncedSave(utmBatch);
  }, [utmBatch, debouncedSave]);
  return null;
}
